// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror:focus {
    outline: none;
  }
  
  .ProseMirror {
    margin-left: .5em;
    padding: .5em;
    min-height: 80px;
  }
  .has-focus {
    outline: none;
  }
  .tiptap {
    > * + * {
      margin-top: 0.75em;
    }
  
    ul,
    ol {
      padding: 0 1rem;
    }
  
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: .5;
    }
  
    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }
  
    pre {
      background: #0D0D0D;
      color: #FFF;
      font-family: 'JetBrainsMono', monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
  
      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }
  
    img {
      max-width: 100%;
      height: auto;
    }
  
    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0D0D0D, 0.1);
    }
  
    hr {
      border: none;
      border-top: 2px solid rgba(#0D0D0D, 0.1);
      margin: 2rem 0;
    }
  } 
  
  
  .tiptap p.is-empty:first-child::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }
  
  
  /* .tiptap p.is-empty::before {
    color: #adb5bd;
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  } */`, "",{"version":3,"sources":["webpack://./src/components/Markdown/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE;MACE,kBAAkB;IACpB;;IAEA;;MAEE,eAAe;IACjB;;IAEA;;;;;;MAME,eAAe;IACjB;;IAEA;MACE,oCAAoC;MACpC,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,uCAAuC;MACvC,qBAAqB;MACrB,qBAAqB;;MAErB;QACE,cAAc;QACd,UAAU;QACV,gBAAgB;QAChB,iBAAiB;MACnB;IACF;;IAEA;MACE,eAAe;MACf,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,yCAAyC;IAC3C;;IAEA;MACE,YAAY;MACZ,wCAAwC;MACxC,cAAc;IAChB;EACF;;;EAGA;IACE,cAAc;IACd,+BAA+B;IAC/B,WAAW;IACX,SAAS;IACT,oBAAoB;EACtB;;;EAGA;;;;;;KAMG","sourcesContent":[".ProseMirror:focus {\n    outline: none;\n  }\n  \n  .ProseMirror {\n    margin-left: .5em;\n    padding: .5em;\n    min-height: 80px;\n  }\n  .has-focus {\n    outline: none;\n  }\n  .tiptap {\n    > * + * {\n      margin-top: 0.75em;\n    }\n  \n    ul,\n    ol {\n      padding: 0 1rem;\n    }\n  \n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      line-height: .5;\n    }\n  \n    code {\n      background-color: rgba(#616161, 0.1);\n      color: #616161;\n    }\n  \n    pre {\n      background: #0D0D0D;\n      color: #FFF;\n      font-family: 'JetBrainsMono', monospace;\n      padding: 0.75rem 1rem;\n      border-radius: 0.5rem;\n  \n      code {\n        color: inherit;\n        padding: 0;\n        background: none;\n        font-size: 0.8rem;\n      }\n    }\n  \n    img {\n      max-width: 100%;\n      height: auto;\n    }\n  \n    blockquote {\n      padding-left: 1rem;\n      border-left: 2px solid rgba(#0D0D0D, 0.1);\n    }\n  \n    hr {\n      border: none;\n      border-top: 2px solid rgba(#0D0D0D, 0.1);\n      margin: 2rem 0;\n    }\n  } \n  \n  \n  .tiptap p.is-empty:first-child::before {\n    color: #adb5bd;\n    content: attr(data-placeholder);\n    float: left;\n    height: 0;\n    pointer-events: none;\n  }\n  \n  \n  /* .tiptap p.is-empty::before {\n    color: #adb5bd;\n    content: attr(data-placeholder);\n    float: left;\n    height: 0;\n    pointer-events: none;\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
